import Address from './Address'
export class BillingInfo {
    RequestID: number;
    BusinessName: string;
    AttentionToContact: string;
    PhoneNumber: string;
    PhoneNumberExtension: string;
    MobilePhone: string;
    Fax: string;
    Email: string;
    Address: Address;
    BillingAddressSameAsDeliveryAddress: boolean;
    EmailInvoices: boolean;
    PayerNumber: string;
    MirrorCustomerNumber: string;
    UnknownPayer: boolean;
    PayerNotAvailableFromMirrorCustomer: boolean;
}

export default BillingInfo;